import { render } from "./CreateShipmentForUser.vue?vue&type=template&id=4544f7b8&scoped=true"
import script from "./CreateShipmentForUser.vue?vue&type=script&lang=js"
export * from "./CreateShipmentForUser.vue?vue&type=script&lang=js"

import "./CreateShipmentForUser.vue?vue&type=style&index=0&id=4544f7b8&scoped=true&lang=css"

import exportComponent from "/codebuild/output/src2981498683/src/lrex-site/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4544f7b8"]])

export default __exports__